"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_API_GROUP_INSTANCE = exports.LIST_GROUP_INSTANCES = exports.GET_UNDERLYING_API_TERMS = void 0;
var _actionify = require("@mulesoft/actionify");
var LIST_GROUP_INSTANCES = exports.LIST_GROUP_INSTANCES = (0, _actionify.buildActionsFor)('List Group Instances');
var GET_UNDERLYING_API_TERMS = exports.GET_UNDERLYING_API_TERMS = (0, _actionify.buildActionsFor)('Get Underlying API Terms');
var UPDATE_API_GROUP_INSTANCE = exports.UPDATE_API_GROUP_INSTANCE = (0, _actionify.buildActionsFor)('Update API Group instance');
//# sourceMappingURL=actionTypes.js.map